import { Calendar, Clock, ArrowRight } from "lucide-react";

function fmtDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
}
function fmtTime(iso) {
  const d = new Date(iso);
  return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
}

export default function SlotStep({ selected, slots, chosenSlot, onChooseSlot, onBack, onContinue }) {
  const slotsByDay = slots.reduce((acc, s) => {
    const day = fmtDate(s.start_at);
    if (!acc[day]) acc[day] = [];
    acc[day].push(s);
    return acc;
  }, {});

  return (
    <div className="brand-card p-6 sm:p-8" data-testid="book-step-2">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-2">
        <div className="flex items-center gap-3">
          {selected.picture ? <img src={selected.picture} className="w-12 h-12 rounded-2xl object-cover" alt="" /> : null}
          <div>
            <div className="font-extrabold text-[#3D405B]">{selected.name}</div>
            <div className="text-xs text-[#7A7D96]">{(selected.specialties || []).slice(0, 3).join(" · ")}</div>
          </div>
        </div>
        <button onClick={onBack} className="text-sm font-semibold text-primary hover:underline">Change counsellor</button>
      </div>

      {/* Lead-time hint — mirrors the server-side 3-day rule so users understand why
          the earliest slot they see isn't today. */}
      <div className="mb-4 px-3 py-2 rounded-xl bg-primary/8 text-[#3D405B] text-xs border border-primary/20 flex items-start gap-2" data-testid="lead-time-hint">
        <Calendar size={13} className="text-primary mt-0.5 shrink-0" />
        <span>
          <strong>Bookings open from 3 days out.</strong> This gives your counsellor time to accept the session before it starts.
        </span>
      </div>

      {Object.keys(slotsByDay).length === 0 ? (
        <div className="text-center py-10 text-[#7A7D96]">No available slots in the next few weeks — please check another counsellor.</div>
      ) : (
        <div className="space-y-5">
          {Object.entries(slotsByDay).map(([day, daySlots]) => (
            <div key={day}>
              <div className="flex items-center gap-2 mb-3">
                <Calendar size={15} className="text-primary" />
                <span className="font-bold text-[#3D405B]">{day}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {daySlots.map((s) => (
                  <button
                    key={s.slot_id}
                    onClick={() => onChooseSlot(s)}
                    className={`px-4 py-2.5 rounded-full text-sm font-bold transition-all ${
                      chosenSlot?.slot_id === s.slot_id
                        ? "bg-primary text-white shadow-md"
                        : "bg-white border border-[#3D405B]/15 text-[#3D405B] hover:bg-[#3D405B]/5"
                    }`}
                    data-testid={`slot-${s.slot_id}`}
                  >
                    <Clock size={13} className="inline -mt-0.5 mr-1" /> {fmtTime(s.start_at)}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-8 flex justify-end">
        <button
          disabled={!chosenSlot}
          onClick={onContinue}
          className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary text-white font-bold shadow-md disabled:opacity-50 hover:-translate-y-0.5 transition-all"
          data-testid="book-continue-btn"
        >
          Continue <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
